<script setup lang="ts">
import { SelectOption } from "@/models/frontend-only/SelectOption";

const { t } = useI18n();

const options: SelectOption[] = [
  {
    label: t("S.LIT_Portrait"),
    value: "portrait",
  },
  {
    label: t("S.LIT_Landscape"),
    value: "landscape",
  },
];

const props = withDefaults(
  defineProps<{
    modelValue?: string;
    id?: string;
  }>(),
  {
    modelValue: "portrait",
    id: undefined,
  },
);

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();

const data = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit("update:modelValue", newValue);
  },
});
</script>

<template>
  <FormSelect
    :options="options"
    :name="id || 'Orientation'"
    v-model="data"
    :label="$t('S.LIT_Orientation')"
    class="hidden xl:block"
    small
  />
  <ToolbarButtonDropdown
    :label="$t('S.LIT_Orientation')"
    icon="fa-ccli-rotate-vertical fa-kit"
    class="xl:hidden"
  >
    <ToolbarButtonDropdownHeader>{{
      $t("S.LIT_Orientation")
    }}</ToolbarButtonDropdownHeader>
    <ToolbarButtonDropdownItem
      v-for="o of options"
      @click="data = o.value"
      :key="o.value"
      :active="data === o.value"
      >{{ o.label }}</ToolbarButtonDropdownItem
    >
  </ToolbarButtonDropdown>
</template>

<style scoped lang="postcss"></style>
